export var SHOW_TYPE;
(function (SHOW_TYPE) {
    SHOW_TYPE[SHOW_TYPE["VERTICAL_DOUBLE"] = 1] = "VERTICAL_DOUBLE";
    // 竖向双列
    SHOW_TYPE[SHOW_TYPE["HORIZONTAL"] = 2] = "HORIZONTAL"; // 横排滑动
})(SHOW_TYPE || (SHOW_TYPE = {}));
export var LOAD_MORE_TYPE;
(function (LOAD_MORE_TYPE) {
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["CLICK"] = 1] = "CLICK";
    // 手动加载
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["SCROLL"] = 2] = "SCROLL"; // 自动加载
})(LOAD_MORE_TYPE || (LOAD_MORE_TYPE = {}));
export var CouponType;
(function (CouponType) {
    CouponType[CouponType["CASH"] = 1] = "CASH";
})(CouponType || (CouponType = {}));
export var CouponStatus;
(function (CouponStatus) {
    CouponStatus[CouponStatus["UNUSED"] = 1] = "UNUSED";
    CouponStatus[CouponStatus["USED"] = 2] = "USED";
    CouponStatus[CouponStatus["EXPIRED"] = 3] = "EXPIRED";
})(CouponStatus || (CouponStatus = {}));
export var STYLE_TYPE;
(function (STYLE_TYPE) {
    STYLE_TYPE[STYLE_TYPE["COMMON"] = 1] = "COMMON";
    STYLE_TYPE[STYLE_TYPE["COMPREHENSIVE_CARD"] = 2] = "COMPREHENSIVE_CARD";
})(STYLE_TYPE || (STYLE_TYPE = {}));
